// src/pages/RegisterPage.js

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/api";
import { FiMail, FiUser, FiLock, FiUserCheck } from "react-icons/fi";

export default function RegisterPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "aluno",
  });

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setIsLoading(true);

    if (formData.password !== formData.confirmPassword) {
      setMessage({ type: "error", text: "As senhas não coincidem." });
      setIsLoading(false);
      return;
    }

    const { confirmPassword, ...payload } = formData;

    try {
      const res = await api.post("/auth/register", payload);
      setMessage({
        type: "success",
        text: res.data?.message || "Cadastro realizado com sucesso!",
      });
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setMessage({
        type: "error",
        text:
          err.response?.data?.message ||
          "Erro interno. Tente novamente.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{
        background:
          "radial-gradient(circle at top, #0f172a, #020617)",
      }}
    >
      {/* MAIN CARD */}
      <div
        className="animate-fadeIn w-full max-w-4xl grid md:grid-cols-2
                   bg-white/10 backdrop-blur-xl shadow-2xl rounded-2xl
                   overflow-hidden border border-white/20"
      >
        {/* LEFT — HERO */}
        <div
          className="hidden md:flex flex-col justify-center p-10 text-white"
          style={{
            background:
              "linear-gradient(135deg, #4f46e5, #7c3aed)",
          }}
        >
          <h1 className="text-4xl font-extrabold leading-tight neon-text">
            Comece sua Jornada!
          </h1>

          <p className="mt-4 text-lg opacity-90">
            Aprenda, ensine e compartilhe conhecimento.
            Cadastre-se como <strong>Aluno</strong> ou{" "}
            <strong>Professor</strong>.
          </p>

          <div className="mt-10 flex items-center gap-3 text-sm opacity-80">
            <span className="w-3 h-3 rounded-full bg-green-400"></span>
            Plataforma segura e rápida ⚡
          </div>
        </div>

        {/* RIGHT — FORM */}
        <div className="p-10">
          <h2 className="text-3xl font-bold text-center mb-8 text-white/40">
            Criar Conta
          </h2>

          {/* MESSAGE */}
          {message && (
            <div
              className={`px-4 py-3 rounded-lg mb-5 text-center border
              ${
                message.type === "success"
                  ? "bg-green-500/20 text-green-300 border-green-400"
                  : "bg-red-500/20 text-red-300 border-red-400"
              }`}
            >
              {message.text}
            </div>
          )}

          {/* ROLE SELECT */}
          <div className="flex gap-2 mb-6">
            {["aluno", "professor"].map((role) => (
              <button
                key={role}
                type="button"
                onClick={() =>
                  setFormData({ ...formData, role })
                }
                className={`flex items-center justify-center gap-2 w-1/2 py-3 rounded-xl
                  font-semibold transition-all border
                  ${
                    formData.role === role
                      ? "bg-indigo-600 text-white border-indigo-500 shadow-lg"
                      : "bg-white/10 text-gray-300 border-gray-600 hover:bg-white/20"
                  }`}
              >
                <FiUserCheck />
                {role === "aluno" ? "Aluno" : "Professor"}
              </button>
            ))}
          </div>

          {/* FORM */}
          <form onSubmit={handleSubmit} className="auth-form">
            {/* NAME */}
            <div className="input-group">
              <FiUser className="input-icon" />
              <input
                type="text"
                name="name"
                placeholder="Nome completo"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isLoading}
              />
            </div>

            {/* EMAIL */}
            <div className="input-group">
              <FiMail className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Seu e-mail"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isLoading}
              />
            </div>

            {/* PASSWORD */}
            <div className="input-group">
              <FiLock className="input-icon" />
              <input
                type="password"
                name="password"
                placeholder="Senha"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={isLoading}
              />
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="input-group">
              <FiLock className="input-icon" />
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirme a senha"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                disabled={isLoading}
              />
            </div>

            {/* SUBMIT */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 mt-4 rounded-xl font-bold text-lg
                         text-white transition-all
                         bg-gradient-to-r from-indigo-500 to-purple-600
                         hover:shadow-lg hover:scale-[1.01]
                         disabled:opacity-50"
            >
              {isLoading ? "Cadastrando..." : "Cadastrar"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm opacity-80">
            Já tem uma conta?{" "}
            <Link
              to="/login"
              className="font-semibold text-indigo-400 hover:underline"
            >
              Acesse aqui
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
